<template>
    <div class="jd-expert--withdraw">
        <div class="jd-block__title">账号信息</div>
        <k-cell title="账号余额">
            <div class="cl-red">
                <span class="k-price">{{getTakeInfo.money|fen2yuan(2)}}</span>
            </div>
        </k-cell>
        <k-hr />
        <k-cell-group>
            <k-field label="取款金额" v-model="info.money" type="number" max="99999" placeholder="取款金额，单位元" />
            <k-field label="银行名称：" v-model="info.bankName" maxLength="30" placeholder="如：建设银行或支付宝" />
            <k-field label="开户行：" v-model="info.bank    " maxLength="30" placeholder="如为支付宝平台可以不填写" />
            <k-field label="姓名：" v-model="info.name" placeholder="真实姓名" maxLength="7"  />
            <k-field label="账号：" v-model="info.account" placeholder="银行或支付宝账号" />
            <k-field label="身份证：" v-model="info.idCard" placeholder="身份证号码" maxLength="18" />
            <k-field label="留言：" v-model="info.remark" type="textarea" placeholder="留言" rows="3" maxLength="100" autosize />
        </k-cell-group>
        <div class="k-cell">
            <k-button type="danger" block @click="submit" :disabled="!isOk || loading" :loading="loading" loading-text="正在提交申请..." loading-type="spinner">提交申请</k-button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    export default {
        name: "withdrawal",
        data() {
            return {
                isOk            : false,
                loading         : false,
                info : {
                    money       : null,
                    bankName    : null,
                    bank        : null,
                    name        : null,
                    account     : null,
                    idCard      : null,
                    remark      : ''
                },
                field : [
                    'money',
                    'bankName',
                    'bank   ',
                    'name',
                    'account',
                    'idCard',
                    'remark'
                ]
            }
        },
        computed : {
            ...mapGetters("jianding", ["getTakeInfo","getTakeList"]),
        },
        methods : {
            ...mapActions("jianding", ["takeMoney","loadTake"]),
            async submit(){
                console.log(JSON.stringify(this.info,null, 2));
                if(this.getTakeInfo.money < this.info.money){
                    this.$toast("超出可提现的金额！");
                    return
                }
                this.loading = true
                let query = this.info;
                await this.takeMoney(query).then( R => {
                    this.$toast("申请成功");
                    this.$router.push({
                        path : '/appraiser'
                    })
                }).catch(err => {
                    this.$toast(err.message);
                });
                this.loading = false

            },
            ckData(){
                let info = this.info;
                let isOk = false;
                this.field.forEach((item,index) => {
                    if(!!info[item]){
                        isOk = true;
                    } else {
                        isOk = false;
                    }
                });
                this.isOk = isOk;
                return isOk
            }
        },
        created() {
            this.loadTake();
        },
        watch : {
            info : {
                handler(nv, ov){
                    //最大为万
                    this.info['money'] = nv.money.slice(0,5);
                    this.ckData();
                },
                deep : true
            }
        }
    }
</script>

<style scoped>

</style>